import CaptureTask from './CaptureTask.vue'
export default CaptureTask



// WEBPACK FOOTER //
// ./src/views/system/captureTask/index.js